<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="graduation icon"></i>
      {{ $t("course pre-inscription") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img
          src="/images/icons/course_assignation.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="ui grid">
            <div class="six wide column">
              <div class="field">
                <label for>{{ $t("student finder") }}</label>
                <div class="ui blue search" ref="student_search">
                  <div class="ui icon input">
                    <input
                      class="prompt"
                      type="text"
                      name="student"
                      :placeholder="$t('search student')"
                      ref="student_search_input"
                    />
                    <i class="search icon"></i>
                  </div>
                  <div class="results"></div>
                </div>
                <div class="ui card" v-if="student">
                  <div class="content">
                    <img
                      class="right floated mini ui image"
                      src="/images/icons/matthew.png"
                    />
                    <div class="header">
                      {{ student.name }}
                    </div>
                    <div class="meta">
                      {{ $t("student card id") }} {{ student.student_id_card }}
                    </div>
                    <div class="description">
                      {{ student.setup.dpi }}
                      <div
                        class="ui mini basic icon labeled button"
                        @click="clear_student"
                      >
                        <i class="erase red icon"></i> {{ $t("clear") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ten wide column">
              <div class="fields">
                <div class="six wide field">
                  <label for="">{{ $t("branch") }}</label>
                  <div
                    class="ui search selection dropdown"
                    ref="branch_dropdown"
                  >
                    <input type="hidden" name="branch" />
                    <i class="dropdown icon"></i>
                    <div class="default text"></div>
                    <div class="menu"></div>
                  </div>
                </div>
                <div class="ten wide field">
                  <label for="">{{ $t("studying time") }}</label>
                  <div
                    class="ui search selection dropdown"
                    ref="studying_time_dropdown"
                  >
                    <input type="hidden" name="studying_time" />
                    <i class="dropdown icon"></i>
                    <div class="default text"></div>
                    <div class="menu"></div>
                  </div>
                </div>
              </div>
              <div class="field">
                <label for="">{{ $t("career") }}</label>
                <div class="ui search selection dropdown" ref="career_dropdown">
                  <input type="hidden" name="career" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
            </div>
          </div>

          <h3 class="ui dividing header">{{ $t("courses") }}</h3>
          <div class="field">
            <label>{{ $t("search course") }}</label>
            <div class="ui search" ref="course_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  :placeholder="$t('search course')"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
          </div>
          <div class="ui relaxed list" v-if="courses">
            <!-- <pre>{{ pensum }}</pre> -->
            <div class="item" v-for="(crs, cidx) in courses" :key="cidx">
              <!-- <i class="book middle aligned icon"></i> -->
              <div class="content">
                <div
                  class="ui tiny basic icon right floated button"
                  @click="delete_course(cidx)"
                >
                  <i class="red trash icon"></i>
                </div>
                <i class="blue book icon"></i>{{ crs.name }}
              </div>
            </div>
          </div>

          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("assign") }}
      </div>
      <div class="ui left floated blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import {
  local_api,
  enterprise_setup,
  error_toast,
  success_toast,
  // init_local_data_datables,
  init_search,
} from "@/utils";
import filters from "@/filters";
import { warning_toast } from "../../../utils";
// import { v4 } from "uuid";

// import { translate_status, translate_type } from "../local_translator";
// import Voided from "./Void.vue";
// filters.translate_status = translate_status;
// filters.translate_type = translate_type;

export default {
  name: "CourseAssignationPreinscriptionModal",
  filters: filters,
  components: {},
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      careers: [],
      branches: [],
      studying_times: [],
      student: undefined,
      courses: [],
      branch_id: undefined,
      studying_time_id: undefined,
      career_id: undefined,
      season_id: undefined,
      form: undefined,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * Check init values
       */
      if (data) {
        // console.log(data);
        if (data.season_id) vm.season_id = data.season_id;
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            /** Init dropdowns */
            window
              .jQuery(vm.$refs.career_dropdown)
              .dropdown("setup menu", {
                values: vm.careers.map((c) => {
                  return { name: c.name, value: c.career_id };
                }),
              })
              .dropdown({
                fullTextSearch: "exact",
                onChange(value) {
                  vm.career_id = value;
                },
              });

            window
              .jQuery(vm.$refs.branch_dropdown)
              .dropdown("setup menu", {
                values: vm.branches.map((b) => {
                  return { name: b.name, value: b.branch_id };
                }),
              })
              .dropdown({
                fullTextSearch: "exact",
                onChange(value) {
                  vm.branch_id = value;
                },
              });

            window
              .jQuery(vm.$refs.studying_time_dropdown)
              .dropdown("setup menu", {
                values: vm.studying_times.map((b) => {
                  return { name: b.name, value: b.studying_time_id };
                }),
              })
              .dropdown({
                fullTextSearch: "exact",
                onChange(value) {
                  vm.studying_time_id = value;
                },
              });

            /** Init student search */
            let onSearchSelect = function (data) {
              vm.student = data.student;
              // let idx = window.jQuery(this).data("i");
              // vm.courses[idx].crs = data.course;
            };
            let onSearchResponse = (data) => {
              let rslt = [];
              data.map((r) => {
                rslt.push({
                  title: r.name,
                  description: r.student_id_card,
                  student: r,
                });
              });
              return { results: rslt };
            };

            init_search(
              vm,
              vm.$refs.student_search,
              "search student",
              onSearchResponse,
              onSearchSelect,
              {},
            );

            /** Init course search */
            let onCourseSearchSelect = function (data) {
              vm.courses.push(data.course);
            };
            let onCourseSearchResponse = (data) => {
              // console.log(data);
              let rslt = [];
              data.map((r) => {
                rslt.push({
                  title: r.name,
                  description: r.name,
                  course: r,
                });
              });
              let obj = { results: rslt };
              // console.log(obj);
              return obj;
            };

            init_search(
              vm,
              vm.$refs.course_search,
              "search course",
              onCourseSearchResponse,
              onCourseSearchSelect,
            );

            /** Form rules */
            vm.form = window.jQuery(vm.$refs.form).form({
              fields: {
                student: ["empty"],
                branch: ["empty"],
                studying_time: ["empty"],
                career: ["empty"],
              },
            });
          },
          onHide() {
            window.jQuery(vm.$refs.career_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.branch_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.studying_time_dropdown).dropdown("clear");
            vm.career_id = undefined;
            vm.branch_id = undefined;
            vm.studying_time_id = undefined;
            vm.student = undefined;
          },
        })
        .modal("show");
    },
    set_catalogs(catalogs) {
      let vm = this;
      vm.careers = catalogs.careers || [];
      vm.branches = catalogs.branches || [];
      vm.studying_times = catalogs.studying_times || [];
      vm.courses = [];
    },
    clear_student() {
      this.student = undefined;
    },
    save() {
      let vm = this;

      if (!vm.courses || !vm.courses.length) {
        warning_toast(vm.$t("no courses added yet"));
      } else {
        let isValid = vm.form.form("validate form");
        if (isValid) {
          local_api(vm, "post", "/course/assignation/do-pre-assign", {
            s: vm.season_id,
            c: vm.career_id,
            b: vm.branch_id,
            sc: vm.studying_time_id,
            st: vm.student ? vm.student.student_id : null,
            cr: vm.courses.map((c) => {
              return c.course_id;
            }),
          })
            .then(() => {
              success_toast(vm.$t("pre-assignation succedded"));
              window.jQuery(vm.$refs.modal).modal("hide");
              vm.$emit("success");
            })
            .catch((err) => {
              error_toast(err);
            });
        }
      }
    },
    delete_course(index) {
      let vm = this;
      vm.courses.splice(index, 1);
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
